import React from 'react';
import './home.css';

const Home = () => {
    return (
        <div className='home-container'>
                <h2 id='hello'>Hello World! 👋</h2>
                <p id='welcome-message'>
                    I'm Valentina 🤓
                    <br/>
                    I sit between technical customers and engineering teams, diagnosing what's broken, automating what's painful, making things work.
                    <br/>
                    Always open to a new adventure! 
                </p>
        </div>
    );
};

export default Home;